export const DEV_ENV = process.env.NODE_ENV !== 'production'
export const API_URL = window.BASE_URL
export const SENTRY_DSN =
  'https://ab9c84ad54cd4b1b80a02746cc9c2783@o132702.ingest.sentry.io/6069415'
